import * as React from 'react';
import '../styles/home.css';
import Modal from '@cloudscape-design/components/modal';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import FileUpload from '@cloudscape-design/components/file-upload';
import FormField from '@cloudscape-design/components/form-field';
import { useState } from 'react';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import Spinner from '@cloudscape-design/components/spinner';
import { addUsage } from './add-usage.js';
import { PDFDocument } from 'pdf-lib';
import organize from '../assets/organize.png';
import constants from '../constants.js';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const OrganizePDF = () => {
  const [visible, setVisible] = React.useState(false);
  const [value, setValue] = React.useState([]);
  const [submitvalue, setSubmitvalue] = useState(constants.organizePDF);
  const [servicevalue, setServicevalue] = useState([]);
  const [filearray, setfilearray] = useState([]);
  const [totalsize, setTotalsize] = useState(0);
  const [notify, setNotify] = useState(null);
  const [error, setError] = useState(null);
  const [pageList, setPageList] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [pageRotations, setPageRotations] = useState({});

  const toggleModal = React.useCallback(
    (service) => () => {
      setVisible(true);
      setValue('');
      setServicevalue(service);
      setSubmitvalue(constants.organizePDF);
      setTotalsize(0);
      setNotify('');
      setError('');
    },
    [],
  );

  const onClickFooterButton = () => {
    setVisible(false);
    setValue('');
    setSubmitvalue(constants.organizePDF);
    setTotalsize(0);
    setNotify('');
    setError('');
    setPageList([]);
    setPageRotations({});
  };

  async function _handleInputChange(e) {
    setValue(e.detail.value);
    let files = e.detail.value;

    const pdfFiles = files.filter((file) => file.type === constants.pdfFileType);

    if (pdfFiles.length !== files.length) {
      setNotify(constants.onlyPdfAllowed);
      setError('error');
    } else {
      setNotify('');
      setError(null);
    }

    let valueAdded = 0;
    for (const file of pdfFiles) {
      valueAdded += file.size;
    }
    setTotalsize(valueAdded / 1000000);
    setfilearray(pdfFiles);
    setPageRotations({});

    // Generate page list for preview
    if (pdfFiles.length > 0) {
      try {
        const file = pdfFiles[0];
        const arrayBuffer = await file.arrayBuffer();

        // Load with PDF.js for rendering
        const pdfJsDoc = await pdfjsLib.getDocument({
          data: arrayBuffer,
          password: '',
        }).promise;

        const pageCount = pdfJsDoc.numPages;
        const pages = [];
        for (let i = 0; i < pageCount; i++) {
          const pdfJsPage = await pdfJsDoc.getPage(i + 1);
          const viewport = pdfJsPage.getViewport({ scale: 0.5 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          context.fillStyle = 'white';
          context.fillRect(0, 0, canvas.width, canvas.height);
          await pdfJsPage.render({
            canvasContext: context,
            viewport,
          }).promise;

          const imageUrl = canvas.toDataURL('image/png');

          pages.push({
            id: i + 1,
            pageNumber: i + 1,
            fileName: file.name,
            thumbnail: imageUrl,
            rotation: 0,
          });
        }
        setPageList(pages);
      } catch (error) {
        console.error('', error);
        setNotify(constants.encryptedFile);
        setError(constants.error);
      }
    }
  }

  async function OrganizingPDF() {
    setSubmitvalue(<Spinner />);
    let files = filearray;

    for (const file of files) {
      if (file.type === constants.pdfFileType) {
        try {
          const arrayBuffer = await file.arrayBuffer();

          // Load the PDF with PDF.js
          const pdfJsDoc = await pdfjsLib.getDocument({
            data: arrayBuffer,
            password: '',
          }).promise;

          // Create a new PDF document using pdf-lib
          const newPdf = await PDFDocument.create();

          for (const page of pageList) {
            const pdfJsPage = await pdfJsDoc.getPage(page.pageNumber);

            const viewport = pdfJsPage.getViewport({ scale: 1.0 });

            // Create a canvas to render the page
            let canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            // Apply rotation if needed
            const rotation = pageRotations[page.id] || 0;

            // Set canvas dimensions based on rotation
            if (rotation === 90 || rotation === 270) {
              canvas.width = viewport.height;
              canvas.height = viewport.width;

              // Translate and rotate context
              context.translate(canvas.width / 2, canvas.height / 2);
              context.rotate((rotation * Math.PI) / 180);
              context.translate(-viewport.width / 2, -viewport.height / 2);
            } else {
              canvas.width = viewport.width;
              canvas.height = viewport.height;

              if (rotation !== 0) {
                // For 180 degrees, just translate and rotate
                context.translate(canvas.width / 2, canvas.height / 2);
                context.rotate((rotation * Math.PI) / 180);
                context.translate(-canvas.width / 2, -canvas.height / 2);
              }
            }

            // Set white background
            context.fillStyle = 'white';
            context.fillRect(0, 0, canvas.width, canvas.height);

            // Render the page to canvas
            await pdfJsPage.render({
              canvasContext: context,
              viewport,
            }).promise;

            // Convert canvas to image and embed in new PDF
            const imgData = canvas.toDataURL('image/png');
            const img = await newPdf.embedPng(imgData);

            // Add page with correct dimensions
            const newPage = newPdf.addPage([canvas.width, canvas.height]);
            newPage.drawImage(img, {
              x: 0,
              y: 0,
              width: canvas.width,
              height: canvas.height,
            });
            canvas.width = 0;
            canvas.height = 0;
            canvas = null;
          }

          const pdfBytes = await newPdf.save();
          const blob = new Blob([pdfBytes], { type: constants.pdfFileType });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `organized_${file.name}`;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } catch (error) {
          console.error('Organization failed:', error);
          if (error.message && (error.message.includes('encrypted') || error.message.includes('password'))) {
            setNotify('This PDF is password protected and cannot be processed.');
          } else {
            setNotify(constants.organizationFailed);
          }
          setError(constants.error);
        }
      } else {
        setNotify(constants.unsupportedFileType);
        setError(constants.error);
      }
    }

    setSubmitvalue(constants.success);
    addUsage('AWESOME PDF TOOLS', '1.0', filearray.length, window.location.href);
    if (error) {
      setVisible(true);
    } else {
      setVisible(false);
    }
    setPageList([]);
  }

  return (
    <div>
      <div className="service-card" onClick={toggleModal(constants.organizePDF)}>
        <div className="service-card-icon">
          <img src={organize} alt="Organize PDF" loading="lazy" />
        </div>
        <h3 className="service-card-title">Organize PDF</h3>
        <p className="service-card-desc">Sort, reorder, rotate, and move pages to front or back</p>
        <div className="service-card-action">
          <span>Get Started</span>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
          </svg>
        </div>
      </div>

      <Modal
        onDismiss={() => {
          setVisible(false);
          setPageList([]);
          setPageRotations({});
        }}
        visible={visible}
        size={pageList.length > 2 ? 'medium' : 'small'}
        footer={
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={onClickFooterButton}>
                {constants.cancel}
              </Button>
              <div>
                {totalsize < 2000 && totalsize > 0 && filearray.length > 0 && pageList.length > 0 ? (
                  <Button variant="primary" onClick={OrganizingPDF}>
                    {submitvalue}
                  </Button>
                ) : (
                  <Button disabled variant="primary">
                    {totalsize > 2000 ? constants.limitExceeded : submitvalue}
                  </Button>
                )}
              </div>
            </SpaceBetween>
          </Box>
        }
        header={servicevalue}
      >
        {servicevalue === constants.organizePDF ? (
          <div>
            <FormField errorText={notify} label={constants.uploadFile} description={constants.onlyPdfSupported}>
              <FileUpload
                onChange={_handleInputChange}
                value={[]}
                i18nStrings={{
                  uploadButtonText: (e) => (e ? constants.chooseFiles : constants.choose),
                  dropzoneText: (e) => (e ? constants.dropFilesToUpload : constants.dropFileToUpload),
                  removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
                  limitShowFewer: constants.showFewerFiles,
                  limitShowMore: constants.showMoreFiles,
                  errorIconAriaLabel: constants.error,
                }}
                showFileLastModified={false}
                showFileSize={false}
                showFileThumbnail={false}
                tokenLimit={1}
                constraintText=""
                accept=".pdf"
              />
            </FormField>

            {pageList.length > 0 && (
              <FormField label={constants.pageOrder} description={constants.dragToReorder}>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '14px',
                    padding: '16px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '12px',
                    minHeight: '140px',
                    background: 'linear-gradient(to bottom, #fafafa, #f5f5f5)',
                  }}
                >
                  {pageList.map((page, index) => (
                    <div
                      key={page.id}
                      draggable
                      onDragStart={() => setDraggedItem(index)}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (draggedItem !== null) {
                          const newPageList = [...pageList];
                          const draggedPage = newPageList[draggedItem];
                          newPageList.splice(draggedItem, 1);
                          newPageList.splice(index, 0, draggedPage);
                          setPageList(newPageList);
                          setDraggedItem(null);
                        }
                      }}
                      style={{
                        width: '120px',
                        borderRadius: '8px',
                        cursor: 'move',
                        overflow: 'hidden',
                        backgroundColor: '#fff',
                        border: '2px solid #e0e0e0',
                        boxShadow: '0 2px 5px rgba(15, 17, 17, 0.1)',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = '#FF9900';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 153, 0, 0.2)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = '#e0e0e0';
                        e.currentTarget.style.boxShadow = '0 2px 5px rgba(15, 17, 17, 0.1)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      {/* Thumbnail */}
                      <div style={{ width: '100%', height: '120px', overflow: 'hidden', backgroundColor: '#f9f9f9' }}>
                        <img
                          src={page.thumbnail}
                          alt={`Page ${page.pageNumber}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            transform: `rotate(${pageRotations[page.id] || 0}deg)`,
                            pointerEvents: 'none',
                          }}
                        />
                      </div>
                      {/* Page label */}
                      <div
                        style={{
                          background: 'linear-gradient(to right, #232F3E, #37475A)',
                          color: '#fff',
                          fontSize: '11px',
                          fontWeight: '600',
                          textAlign: 'center',
                          padding: '4px 0',
                          letterSpacing: '0.3px',
                        }}
                      >
                        Page {page.pageNumber}
                      </div>
                      {/* Action bar */}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '5px 4px',
                          backgroundColor: '#fafafa',
                          borderTop: '1px solid #eee',
                        }}
                      >
                        {/* Move to First */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (index === 0) return;
                            const newPageList = [...pageList];
                            const [moved] = newPageList.splice(index, 1);
                            newPageList.unshift(moved);
                            setPageList(newPageList);
                          }}
                          title="Move to first"
                          disabled={index === 0}
                          style={{
                            width: '28px',
                            height: '28px',
                            border: '1px solid',
                            borderColor: index === 0 ? '#ddd' : '#232F3E',
                            borderRadius: '6px',
                            backgroundColor: index === 0 ? '#f0f0f0' : '#232F3E',
                            cursor: index === 0 ? 'default' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill={index === 0 ? '#bbb' : '#fff'}>
                            <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z" />
                          </svg>
                        </button>
                        {/* Rotate */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            const currentRotation = pageRotations[page.id] || 0;
                            setPageRotations({
                              ...pageRotations,
                              [page.id]: (currentRotation + 90) % 360,
                            });
                          }}
                          title="Rotate 90°"
                          style={{
                            width: '28px',
                            height: '28px',
                            border: '1px solid #FF9900',
                            borderRadius: '6px',
                            background: 'linear-gradient(to bottom, #FF9900, #e88b00)',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="#fff">
                            <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
                          </svg>
                        </button>
                        {/* Move to Last */}
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            if (index === pageList.length - 1) return;
                            const newPageList = [...pageList];
                            const [moved] = newPageList.splice(index, 1);
                            newPageList.push(moved);
                            setPageList(newPageList);
                          }}
                          title="Move to last"
                          disabled={index === pageList.length - 1}
                          style={{
                            width: '28px',
                            height: '28px',
                            border: '1px solid',
                            borderColor: index === pageList.length - 1 ? '#ddd' : '#232F3E',
                            borderRadius: '6px',
                            backgroundColor: index === pageList.length - 1 ? '#f0f0f0' : '#232F3E',
                            cursor: index === pageList.length - 1 ? 'default' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 0,
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill={index === pageList.length - 1 ? '#bbb' : '#fff'}>
                            <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </FormField>
            )}
          </div>
        ) : (
          <div></div>
        )}
        <br />
        Current size: {totalsize.toFixed(2)}
        <span>MB</span>
        <br />
        Total maximum limit: 2GB
      </Modal>
    </div>
  );
};

export default OrganizePDF;
